const config = {
  ENVIRONMENT_NAME: 'testing',
  forwoodId: {
    URL: 'https://id.testing.saas.forwoodsafety.com',
    USER_TOKEN_URL: 'https://byuxoxeeb7.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://bhwyl8a7y6.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.testing.saas.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.testing.saas.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.testing.saas.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.saas.forwoodsafety.com',
    WEBSOCKET: 'wss://rs4k9t9nml.execute-api.us-west-2.amazonaws.com/testing'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
